var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 149,
    viewBox: "0 0 151 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.9265,
    y: 32.3345,
    width: 20.9466,
    height: 20.9925,
    fill: "black",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5983,
    y: 25.2969,
    width: 14.8015,
    height: 14.8346,
    fill: "black",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.873,
    y: 132.5,
    width: 13.9549,
    height: 13.9237,
    transform: "rotate(-90 55.873 132.5)",
    fill: "black",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.0028,
    y: 132.5,
    width: 13.9549,
    height: 13.9237,
    transform: "rotate(-90 19.0028 132.5)",
    fill: "black",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 118.201,
    y: 41.1316,
    width: 13.9237,
    height: 13.9549,
    fill: "black",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 70.7968,
    y: 101.71,
    width: 13.9549,
    height: 14.8015,
    transform: "rotate(-90 70.7968 101.71)",
    fill: "black",
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 102.4,
    y: 41.1316,
    width: 14.8015,
    height: 13.9549,
    fill: "black",
    stroke: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 70.7968,
    y: 117.545,
    width: 14.8346,
    height: 14.8015,
    transform: "rotate(-90 70.7968 117.545)",
    fill: "black",
    stroke: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5983,
    y: 71.9212,
    width: 14.8015,
    height: 14.8346,
    fill: "black",
    stroke: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 102.4,
    y: 132.5,
    width: 13.9549,
    height: 14.8015,
    transform: "rotate(-90 102.4 132.5)",
    fill: "black",
    stroke: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 18.125,
    y: 101.71,
    width: 13.9549,
    height: 14.8015,
    transform: "rotate(-90 18.125 101.71)",
    fill: "black",
    stroke: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 102.4,
    y: 56.0864,
    width: 14.8015,
    height: 14.8346,
    fill: "black",
    stroke: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5983,
    y: 117.545,
    width: 14.8346,
    height: 14.8015,
    transform: "rotate(-90 86.5983 117.545)",
    fill: "black",
    stroke: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5983,
    y: 87.7556,
    width: 14.8015,
    height: 13.9549,
    fill: "black",
    stroke: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 118.201,
    y: 132.5,
    width: 13.9549,
    height: 13.9237,
    transform: "rotate(-90 118.201 132.5)",
    fill: "black",
    stroke: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9265,
    y: 101.71,
    width: 13.9549,
    height: 13.9237,
    transform: "rotate(-90 33.9265 101.71)",
    fill: "black",
    stroke: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 22.625,
    y: 21,
    width: 43.5496,
    height: 43.6617,
    stroke: "black",
    strokeWidth: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode1);
export default __webpack_public_path__ + "static/media/qr-code-1.f2929c9eebfbd5257fd8d0f53f599889.svg";
export { ForwardRef as ReactComponent };